import { render } from "./company-settings.vue?vue&type=template&id=36ab2d3a&scoped=true"
import script from "./company-settings.vue?vue&type=script&lang=js"
export * from "./company-settings.vue?vue&type=script&lang=js"

import "./company-settings.vue?vue&type=style&index=0&id=36ab2d3a&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ab2d3a"]])

export default __exports__